import { computePosition, autoPlacement, offset, arrow, autoUpdate, shift } from '@floating-ui/dom';

// Sets element attribute
function setElementAttribute(id, attribute, value) {
    const element = document.getElementById(id);
    if (element) {
        element[attribute] = value;
    }
}

function setAttrByArray(element, attrArray) {
    for (let { attr, value } of attrArray) {
        element.setAttribute(attr, value);
    }
}

// Show/hide spinner to give container time to load
function toggleSpinnerAndContainer(spinnerId, containerId, delay) {
    const spinner = document.getElementById(spinnerId);
    const container = document.getElementById(containerId);

    if ( spinner ) {
        spinner.classList.add('visible-container');
        spinner.style.display = 'block';
    }

    if ( spinner && container ) {
        setTimeout(() => {
            spinner.classList.remove('visible-container');
            spinner.style.display = 'none';
            container.classList.add('visible-container');
            container.classList.remove('hidden-container');
        }, delay);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    function scrollToElementWithOffset(elementId, offset) {
        const element = document.getElementById(elementId);
        if (element) {
            const scrollAnchor = document.createElement('a');
            scrollAnchor.classList.add('scroll-anchor');
            scrollAnchor.style.top = `-${offset}px`;
            scrollAnchor.style.visibility = 'hidden';

            element.parentNode.insertBefore(scrollAnchor, element);
            scrollAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setTimeout(() => scrollAnchor.remove(), 1000);
        }
    }

    function handleLinkClick(event) {
        const targetId = event.currentTarget.getAttribute('href').split('#')[1].split('?')[0];
        if (document.getElementById(targetId)) {
            event.preventDefault();
            scrollToElementWithOffset(targetId, 107);
        }
    }

    // Add event listeners to all anchor links
    const anchorLinks = document.querySelectorAll('a[href*="#"]');
    anchorLinks.forEach(link => {
        link.addEventListener('click', handleLinkClick);
    });

    // Check if there's an anchor in the URL on page load and splits off parameters
    const url = new URL(window.location.href);
    const hash = url.hash.split('?')[0];
    const anchorFromURL = hash.substring(1);
    if (anchorFromURL) {
        setTimeout(() => scrollToElementWithOffset(anchorFromURL, 107), 100);
    }
});


const closeModalButton = document.getElementById('closeModal');
const exitNotificationCollapse = document.getElementById('exitNotification');

if (closeModalButton && exitNotificationCollapse) {
    closeModalButton.addEventListener('click', function() {
        const bsCollapse = new bootstrap.Collapse(exitNotificationCollapse, {
            toggle: false
        });
        bsCollapse.hide();
    });
}



// Function to initialize a tooltip
function initTooltip(reference, tooltip) {
    const tooltipArrow = tooltip.querySelector('[data-popper-arrow]');
    let cleanup = null;

    function showTooltip() {
        tooltip.setAttribute('data-show', '');
        cleanup = autoUpdate(reference, tooltip, () => {
            computePosition(reference, tooltip, {
                placement: 'top',
                middleware: [
                    offset(8),
                    autoPlacement({
                        placement: 'bottom-start',
                        // Won't also choose 'end' alignments if those fit better
                        autoAlignment: false,
                        allowedPlacements: ['top', 'bottom'],
                    }),
                    shift({
                        crossAxis: true,
                    }),
                    arrow({ element: tooltipArrow }),
                ],
            }).then(({ x, y, placement, middlewareData }) => {
                Object.assign(tooltip.style, {
                    left: `${x}px`,
                    top: `${y}px`,
                });

                const { x: arrowX, y: arrowY } = middlewareData.arrow;
                if (arrowX !== undefined) {
                    tooltipArrow.style.left = `${arrowX}px`;
                }
                if (arrowY !== undefined) {
                    tooltipArrow.style.top = `${arrowY}px`;
                }

                tooltip.setAttribute('data-placement', placement);
            });
        });
    }

    function hideTooltip() {
        tooltip.removeAttribute('data-show');
        if (cleanup) {
            cleanup();
            cleanup = null;
        }
    }

    reference.addEventListener('mouseenter', showTooltip);
    reference.addEventListener('mouseleave', hideTooltip);
}

// Initialize all tooltips on the page
document.querySelectorAll('.tooltip-reference').forEach(reference => {
    reference.addEventListener('click', function(event){
      event.preventDefault()
    });
    const tooltipId = reference.getAttribute('data-tooltip-id');
    const tooltip = document.getElementById(tooltipId);
    if (tooltip) {
        initTooltip(reference, tooltip);
    }
});

export {
    setElementAttribute, 
    setAttrByArray,
    toggleSpinnerAndContainer,
};